import React from "react";

export const UiHorizontalButtonGroup = (props) => {
  const className = `df-horizontal-btn-group ${props.className || ""}`.trim();

  return (
    <>
      <div className={className}>{props?.children}</div>
    </>
  );
};
